import { SocketContext } from "context/socket";
import { useContext, useEffect } from "react";

const useCallbackOnClipUpdate = ({ streamId, onClipUpdate }) => {
  const { webhookSocket } = useContext(SocketContext);

  useEffect(() => {
    if (!streamId) return;
    const subscribe = (id) => webhookSocket.on(`updated-clip-${id}`, onClipUpdate);
    const unsubscribe = (id) => webhookSocket.off(`updated-clip-${id}`, onClipUpdate);

    if (Array.isArray(streamId)) {
      streamId.forEach(subscribe);
      return () => {
        streamId.forEach(unsubscribe);
      };
    } else {
      subscribe(streamId);
      return () => {
        unsubscribe(streamId);
      };
    }
  }, [onClipUpdate, streamId, webhookSocket]);
};

export default useCallbackOnClipUpdate;
